import React from "react";
import Header from "../components/header/Header";
function News() {
  return (
    <div>
      <Header />
      News here
    </div>
  );
}
export default News;
